import React from 'react';
import { useInfiniteHits, Highlight, Snippet } from 'react-instantsearch';
import type { Hit } from 'instantsearch.js';

import { useSearchListContext } from '../context/SearchListProvider';
import SearchTeaser, { SearchTeaserProps } from './SearchTeaser';

const SearchListResults = () => {
  const { i18n, resultsHidden } = useSearchListContext();

  const { hits, results, isLastPage, showMore } = useInfiniteHits({
    showPrevious: false,
    escapeHTML: false
  });

  if (hits.length === 0 || resultsHidden) return null;

  return (
    <div className="search-list__results grid-inner">
      <div className="search-list__hits">
        {/*@ts-ignore */}
        {hits.map((item: Hit<SearchTeaserProps>) => (
          <SearchTeaser
            {...item}
            key={item.id}
            highlightedHeadline={<Highlight hit={item} attribute="headline" />}
            highlightedIntro={
              //@ts-ignore
              item._highlightResult?.intro?.matchLevel !== 'none' ? (
                <Highlight hit={item} attribute="intro" />
              ) : //@ts-ignore
              item._highlightResult?.content?.matchLevel !== 'none' ? (
                <Snippet hit={item} attribute="content" />
              ) : (
                <Highlight hit={item} attribute="intro" />
              )
            }
          />
        ))}
      </div>

      {!isLastPage && results && (
        <div className="search-list__load-more">
          <p className="typo-copy">
            {i18n.viewing
              .replace('[[count]]', `${hits.length}`)
              .replace('[[total]]', `${results?.nbHits}`)}
          </p>
          <div
            className="search-list__progress"
            style={
              {
                '--search-progress': hits.length / results?.nbHits
              } as React.CSSProperties
            }
          />
          <button
            type="button"
            className="button search-list__teaser-cta"
            onClick={showMore}
          >
            <span className="button__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <path d="M13 7.49581L7.92086 12.575L2.84171 7.49581L3.66667 6.67085L7.33753 10.3417L7.33752 3L8.50419 3L8.50419 10.3417L12.175 6.67086L13 7.49581Z" />
              </svg>
            </span>
            <span className="button__label">{i18n.loadMore}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchListResults;
